import { Panel } from "@/components/ui-bits";

const fmt = (n) => +Number(n || 0).toFixed(2);

/** Live stock vs counted draft, per material. */
export default function StockTakeComparison({ rows }) {
  return (
    <Panel title="Live stock vs counted">
      {rows.length === 0 ? (
        <div className="text-sm text-stone-500 py-6 text-center">No stock to compare yet.</div>
      ) : (
        <div className="max-h-[420px] overflow-y-auto -mx-1 px-1" data-testid="stocktake-comparison">
          <table className="w-full text-sm">
            <thead className="text-left text-[11px] uppercase tracking-wider text-stone-500 sticky top-0 bg-card">
              <tr>
                <th className="py-2">Material</th>
                <th className="text-right">Live now</th>
                <th className="text-right">Counted</th>
                <th className="text-right">Change</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const diff = r.draft - r.live;
                const notCounted = r.draft === 0 && r.live > 0;
                return (
                  <tr key={r.material_id} className="border-t border-border" data-testid={`stocktake-compare-${r.material_id}`}>
                    <td className="py-2">
                      <div className="font-medium">{r.name}</div>
                      {notCounted && <div className="text-[11px] text-amber-700">Not counted yet: will go to 0</div>}
                    </td>
                    <td className="text-right tnum text-stone-600">{fmt(r.live)} {r.unit}</td>
                    <td className="text-right tnum font-semibold">{fmt(r.draft)} {r.unit}</td>
                    <td className={`text-right tnum font-semibold ${diff > 0 ? "text-emerald-700" : diff < 0 ? "text-rose-700" : "text-stone-400"}`}>
                      {diff > 0 ? "+" : ""}{fmt(diff)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
